import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const checkboxVariants = cva(
  "peer size-6 shrink-0 rounded-[3px] border border-gray-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
  {
    variants: {
      variant: {
        blue: "data-[state=checked]:bg-blue-600 data-[state=checked]:text-white",
        deepblue: "data-[state=checked]:bg-blue-900 data-[state=checked]:text-white",
        red: "data-[state=checked]:bg-red-700 data-[state=checked]:text-white",
      },
    },
    defaultVariants: {
      variant: "blue",
    },
  },
);

export interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
    VariantProps<typeof checkboxVariants> {}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, variant, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:border-gray-400 disabled:bg-gray-400 disabled:data-[state=checked]:border-gray-400 disabled:data-[state=checked]:bg-gray-400 disabled:data-[state=checked]:text-gray-600",
        checkboxVariants({ variant }),
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
        <Check className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
